import React from 'react'
import HeaderSection from '../../components/headersection/HeaderSection'
import './bestvideo.css'
import useAppContext from '../../hook/useAppContext'

const BestVideo = () => {

      const {user} = useAppContext()
      const {videos} = user 

      if(videos.code) return 

      const video = videos[0]

      return (
            <div className="best_video">
                  <HeaderSection title={`Latest Video`} />
                  <div className="best_video__content">
                        <div className="best_video__box">
                              <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${video.id_video}?si=PxPnbulIPQRezN2T`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        <div className="best_video__title">
                              <p>{video.title}</p>
                        </div>
                  </div>
            </div>
      )
}

export default BestVideo
